module.exports = __webpack_public_path__ + "static/handyman-ff06574f9e3605cf6c6b1e391f453dfb.jpg";